function onCardClick(e) {
  /**
   * This functions intercepts clicks that happen within a card (`.clickable-card`).
   * If the click happens within a "clickable" element, the event is stopped, so it won't bubble up.
   * If there's some text selection, nothing happens.
   * At last, the main link is clicked.
   */
  const card = e.target.closest(".clickable-card");
  if (card) {
    const mainLink = card.querySelector(`[class*="main-link"]`);
    const clickable = e.target.closest(".clickable");
    if (e.target !== mainLink) {
      // Clicking inside the card, but not on the main link.
      if (clickable) {
        e.stopPropagation();
      } else if (mainLink) {
        const textSelected = window.getSelection().toString();

        if (!textSelected) {
          mainLink.click();
        }
      }
    }
  }
}

export default onCardClick